import useDebounceCallback from 'hooks/useDebounceCallback'
import { useMemo, useState } from 'react'
import { PaymentSelectControlProps, PaymentSelectProps } from './types'

export const usePaymentSelectControl = <T>({ ...props }: PaymentSelectProps<T>): PaymentSelectControlProps<T> => {
  const [isOpen, setOpen] = useState(false)

  return useMemo(() => {
    return {
      isOpen,
      open: () => setOpen(true),
      close: () => setOpen(false),
      onOpenChange: setOpen,
      ...props,
    }
  }, [isOpen, props])
}

type FilterFn<T> = (opts: T[], searchStr: string) => T[]

export const useFilterOptionsBySearch = <T>({
  options,
  filterFn,
}: {
  options: T[]
  filterFn: FilterFn<T> | Array<FilterFn<T>>
}) => {
  const [searchString, setSearchString] = useState<string>('')
  const debounce = useDebounceCallback()
  return useMemo(() => {
    let opts = [...options]

    if (Array.isArray(filterFn)) {
      for (const fn of filterFn) {
        opts = fn(opts, searchString)
      }
    } else {
      opts = filterFn(opts, searchString)
    }

    return {
      onChange: (value) => debounce(() => setSearchString(value), 300),
      options: opts,
      typedValue: searchString,
    }
  }, [options, searchString, searchString])
}
